var _rect, _rect2, _path, _path2, _circle, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileDev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 160,
    viewBox: "0 0 240 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 160,
    rx: 8,
    fill: "#1E293B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 30,
    width: 70,
    height: 100,
    rx: 8,
    stroke: "#4C6FFF",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 45H155",
    stroke: "#4C6FFF",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 115H155",
    stroke: "#4C6FFF",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 123,
    r: 4,
    fill: "#4C6FFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 35,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#4C6FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDev);
export default __webpack_public_path__ + "static/media/mobile-dev.97c22de72bd0b4900c6430ac272a793f.svg";
export { ForwardRef as ReactComponent };